export enum PdfType {
  PRINT = 'PRINT',
  DRAFT = 'DRAFT',
}
